import React from "react";
import styles from "./ProgressPill.module.scss";

export interface ProgressPillProps {
  number: number;
  domain: string;
  totalDomains: number;
}

const ProgressPill: React.FC<ProgressPillProps> = ({
  number,
  domain,
  totalDomains,
}) => {
  const shortDomain = domain.split(" ")[0];

  return (
    <div className={styles.container} data-testid="assessment-progress-pill">
      {Array.from({ length: totalDomains }).map((_, i) =>
        i === number - 1 ? (
          <span
            key={i}
            className={styles.pill}
          >{`${number}  ·  ${shortDomain}`}</span>
        ) : (
          <span
            key={i}
            className={`${styles.segment} ${
              i < number - 1 ? styles.filled : ""
            }`}
          />
        )
      )}
    </div>
  );
};

export default ProgressPill;
